import React from 'react';

import FadeIn from 'src/components/elements/FadeIn/FadeIn';

import { CARDS_DATA } from './constants';

import styles from './FAQ.scss';

const FAQ = () => (
  <div className={styles.faq}>
    <div className={styles.textWrapper}>
      <div>
        <FadeIn className={styles.title} delay={0.2}>
          <span className={styles.titleThin}>Solar Cash</span>
          <br />
          <span className={styles.titleThin}>program</span> rules
        </FadeIn>
      </div>
      <FadeIn className={styles.description} delay={0.4}>
        The term &laquo;Solar Cash&raquo; refers to&nbsp;&laquo;bonuses&raquo; that allows you
        to&nbsp;reduce the cost of&nbsp;services on&nbsp;the Solartrip website and mobile app,
        either partially or&nbsp;in&nbsp;full, by&nbsp;providing a&nbsp;discount equal to&nbsp;the
        bonus amount
      </FadeIn>
    </div>
    <FadeIn delay={0.6}>
      <div className={styles.faqCards}>
        {CARDS_DATA.map((card) => (
          <div key={card.id} className={styles.faqCard}>
            <div className={styles.faqCardTitle} dangerouslySetInnerHTML={{ __html: card.title }} />
            <div
              className={styles.faqCardDescription}
              dangerouslySetInnerHTML={{ __html: card.description }}
            />
            {card.buttonCaption && (
              <button
                type="button"
                className={styles.faqCardButton}
                onClick={() => {
                  window.open(card.buttonAction, '_blank');
                }}
              >
                {card.buttonCaption}
              </button>
            )}
          </div>
        ))}
      </div>
    </FadeIn>
  </div>
);

export default FAQ;
